import { useTranslation } from 'react-i18next';

export default function Features() {
  const { t } = useTranslation();
  
  const features = [
    {
      icon: 'ri-calendar-check-fill',
      title: t('features.scheduling.title'),
      description: t('features.scheduling.description'),
      stats: t('features.scheduling.stats'),
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: 'ri-broadcast-fill',
      title: t('features.broadcast.title'),
      description: t('features.broadcast.description'),
      stats: t('features.broadcast.stats'),
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'ri-dashboard-3-fill',
      title: t('features.sharedInbox.title'),
      description: t('features.sharedInbox.description'),
      stats: t('features.sharedInbox.stats'),
      color: 'from-green-500 to-emerald-500'
    },
    {
      icon: 'ri-line-chart-fill',
      title: t('features.analytics.title'),
      description: t('features.analytics.description'),
      stats: t('features.analytics.stats'),
      color: 'from-orange-500 to-red-500'
    },
    {
      icon: 'ri-shield-check-fill',
      title: t('features.security.title'),
      description: t('features.security.description'),
      stats: t('features.security.stats'),
      color: 'from-indigo-500 to-purple-500'
    }
  ];

  return (
    <section 
      className="relative py-24 px-6 overflow-hidden"
      style={{
        background: 'linear-gradient(180deg, #000000 0%, #1b2433 50%, #000000 100%)'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/5 via-transparent to-purple-900/5"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/10 border border-blue-500/30 rounded-full mb-6">
            <i className="ri-star-fill text-blue-400"></i>
            <span className="text-blue-300 text-sm font-medium">{t('features.badge')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t('features.title')}<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">{t('features.titleHighlight')}</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            {t('features.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group relative bg-gray-950/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 hover:border-gray-700 transition-all duration-300 hover:scale-105 cursor-pointer"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-gray-800/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
              
              <div className="relative z-10">
                <div className={`w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br ${feature.color} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${feature.icon} text-3xl text-white`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-gray-400 leading-relaxed mb-4">{feature.description}</p>
                
                <div className="inline-flex items-center gap-2 px-3 py-1 bg-gray-900/80 border border-gray-800 rounded-full">
                  <i className="ri-arrow-up-line text-green-400 text-sm"></i>
                  <span className="text-green-400 text-sm font-medium">{feature.stats}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-purple-900/30 to-green-900/30 backdrop-blur-sm border border-purple-500/30 rounded-2xl p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            <i className="ri-rocket-fill text-purple-400 mr-3"></i>
            {t('features.cta.title')}
          </h3>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            {t('features.cta.subtitle')}
          </p>
          <a 
            href="https://api.whatsapp.com/send/?phone=5519988332466&text=Ol%C3%A1%2C+estou+vindo+pelo+site+da+Automat.&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-8 py-4 bg-gradient-to-r from-purple-600 to-green-600 text-white font-semibold rounded-lg hover:scale-105 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/50 whitespace-nowrap cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <i className="ri-play-circle-fill text-xl"></i>
              {t('features.cta.button')}
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
